import { I18n } from 'react-redux-i18n';

import { api, mergeParams, wrapParams } from '../../api';
import { SHOW_LOADING, HIDE_LOADING } from './types/loadingTypes';

import { showToast } from './toastrActions';
import { getAuthUser } from './authActions';
const user = getAuthUser();

export function getAllInvoices(params) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    return new Promise((resolve, reject) => {

      api.get('Invoice/AllInvoices', { params }).then((response) => {

        dispatch({
          type: HIDE_LOADING,
        });

        resolve(response.data.return);

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        reject(error.response.data.return);

      });

    });

  };

}

export function searchInvoice(params) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    return new Promise((resolve, reject) => {

      api.get('Invoice', { params }).then((response) => {

        dispatch({
          type: HIDE_LOADING,
        });

        resolve(response.data.return);

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        reject(error.response.data.return);

      });

    });

  };

}

export function save(data) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    let saveData = { ...data, userId: user.IdUser, companyId: user.context.idCompany };


    let request = api.post('Invoice/InsertInvoice', wrapParams(saveData));


    return new Promise((resolve, reject) => {

      request.then(
        (response) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('success', '', 'Dados da Nota salvos com sucesso');

          resolve(response);

        },
        (error) => {

          dispatch({
            type: HIDE_LOADING,
          });


          showToast('error', '', error.response.data.message || 'Ocorreu um erro ao salvar os dados da Nota');

          reject(error.response.data.errors);

        },
      );

    });

  };

}

export function saveLote(data) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    let request = api.post('Invoice/InsertInvoiceLot', wrapParams(data));


    return new Promise((resolve, reject) => {

      request.then(
        (response) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('success', '', 'Notas em lote salvos com sucesso');

          resolve(response);

        },
        (error) => {

          dispatch({
            type: HIDE_LOADING,
          });

          console.log(error);
          showToast('error', '', 'Ocorreu um erro ao salvar os dados de Notas em lote');

          reject(error.response.data.errors);

        },
      );

    });

  };

}



// WEBPACK FOOTER //
// ./src/redux/actions/invoiceActions.js